import { useEffect, useState } from 'react';

export function useVideoThumbnail(url: string | null | undefined, time: number = 0.5): string | null {
  const [thumb, setThumb] = useState<string | null>(null);

  useEffect(() => {
    if (!url) return;
    let cancelled = false;

    const video = document.createElement('video');
    video.crossOrigin = 'Anonymous';
    video.src = url;
    video.muted = true;
    video.preload = 'metadata';

    video.addEventListener('loadeddata', () => {
      try {
        video.currentTime = time;
      } catch {
        // safari sometimes throws if seek before metadata ready
      }
    });

    video.addEventListener('seeked', () => {
      if (cancelled) return;
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      setThumb(canvas.toDataURL('image/jpeg', 0.6));
    });

    return () => {
      cancelled = true;
      video.removeAttribute('src');
      video.load();
    };
  }, [url, time]);

  return thumb;
}
